import { render, staticRenderFns } from "./main.vue?vue&type=template&id=17844f08&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17844f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17844f08')) {
      api.createRecord('17844f08', component.options)
    } else {
      api.reload('17844f08', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=17844f08&scoped=true", function () {
      api.rerender('17844f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/popup/schedule/tab-fmt/main.vue"
export default component.exports